import { ATextInput, ATextInputBaseProps } from '../inputs';

export interface ABusinessCodeInputProps extends ATextInputBaseProps<string> {}

export default function ABusinessCodeInput(props: ABusinessCodeInputProps) {
    return <ATextInput {...props} maxLength={9} minLength={9} regExp={/^(\d{7})\-(\d{1})$/} />;
}
